<p-dialog
	[visible]="visible()"
	(visibleChange)="onVisibleChange($event)"
	[modal]="true"
	[closable]="true"
	[draggable]="false"
	[resizable]="false"
	[style]="{ width: '640px' }"
	[header]="duplicateCount() + ' duplicate file(s) detected'"
	styleClass="upload-duplicate-dialog"
>
	<div class="dup-actions">
		<button
			type="button"
			pButton
			class="p-button-sm"
			(click)="applyAll('replace')"
		>
			Replace all
		</button>
		<button
			type="button"
			pButton
			class="p-button-sm p-button-secondary"
			(click)="applyAll('new')"
		>
			Upload all as new
		</button>
	</div>

	<div class="dup-list">
		@for (row of rows(); track row.row.file.name; let i = $index) {
			<div class="dup-row">
				<div class="dup-row-main">
					<div class="dup-row-name" [title]="row.row.file.name">{{ row.row.file.name }}</div>
					<div class="dup-row-meta">
						{{ formatSize(row.row.file.size) }}
						·
						existing: {{ row.row.existing.name }}
					</div>
					@if (!row.extensionMatches) {
						<div class="dup-row-warning">
							Extension differs ({{ row.row.existing.name }}) — upload as new only
						</div>
					}
				</div>
				<div class="dup-row-actions">
					<label class="dup-radio" [class.dup-radio--disabled]="!row.extensionMatches">
						<input
							type="radio"
							[name]="'dup-' + i"
							[checked]="row.action === 'replace'"
							[disabled]="!row.extensionMatches"
							(change)="setRowAction(i, 'replace')"
						/>
						<span>Replace</span>
					</label>
					<label class="dup-radio">
						<input
							type="radio"
							[name]="'dup-' + i"
							[checked]="row.action === 'new'"
							(change)="setRowAction(i, 'new')"
						/>
						<span>Upload as new</span>
					</label>
				</div>
			</div>
		}
	</div>

	@if (nonDuplicateCount() > 0) {
		<div class="dup-non-duplicates">
			+ {{ nonDuplicateCount() }} file(s) will be uploaded as new
		</div>
	}

	<ng-template #footer>
		<button type="button" pButton class="p-button-text" (click)="onCancel()">Cancel</button>
		<button type="button" pButton class="p-button-primary" (click)="onConfirm()">
			Upload {{ totalCount() }} file(s)
		</button>
	</ng-template>
</p-dialog>
